import getCSRFCookie from "./getCSRFCookie";

const headerName = (namespace, key) => namespace ? `${namespace}-${key}` : `X-${key}`;

/**
 * @param {Headers} [headers]
 * @param {Object}  [user]
 * @param {String}  [namespace]
 *
 * @return {Headers} Headers including authentication shenanigans
 */
export default function getAuthHeaders(headers, user, namespace) {
  headers = headers || new Headers();

  if (user) {
    headers.append(headerName(namespace, "Iss"), "self");
    headers.append(headerName(namespace, "Uid"), user.uid);
    headers.append(headerName(namespace, "Roles"), user.roles);
    headers.append(headerName(namespace, "Portfolios"), user.portfolios.map(portfolio => portfolio.uid));
    headers.append(headerName(namespace, "Email"), user.email);
  }

  headers.append("X-CSRF-Token", getCSRFCookie());

  return headers;
}
